import { lazyLoad } from 'utils/loadable';
import { withoutGlobalServiceGroupFilter } from 'app/components/BasicTable/withoutGlobalServiceGroupFilter';

export const SavedViewDetailsPage = lazyLoad(
  () => import('./index'),
  module => withoutGlobalServiceGroupFilter(module.SavedViewDetailsPage),
);
